// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-dialog {\n    margin: 0;\n    padding: 0;\n    min-height: 100%;\n}\n.v-dialog-container {\n    margin: 2rem;\n}\n.v-dialog-container .v-dialog-btn {\n    color:#4d994d;\n    font-weight: bold;\n}\n.v-dialog-container .v-dialog-btn.v-dialog-btn-danger {\n    font-weight: lighter;\n}\n", ""]);
// Exports
module.exports = exports;
